// extracted by mini-css-extract-plugin
export default {"native-dialog-reset":"NativeDialogWrapper_native-dialog-reset__V2T4Q","dialog-paper":"NativeDialogWrapper_dialog-paper__kfshk"};